import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=198c115d&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198c115d')) {
      api.createRecord('198c115d', component.options)
    } else {
      api.reload('198c115d', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=198c115d&", function () {
      api.rerender('198c115d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20E113LHZtKiR/JS/comp/childrenage.vue"
export default component.exports